var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.414 5.296 29.132.494l-3.957.019-3.32 3.379a6.67 6.67 0 0 0-1.856-.26H7.834v18.536l14.601-14.86c.94.744 1.55 1.91 1.55 3.22 0 2.248-1.798 4.066-3.987 4.066h-.58L2.808 31.5h3.94l3.065-3.12H20c3.75 0 6.778-3.102 6.778-6.89a6.91 6.91 0 0 0-2.678-5.477 6.953 6.953 0 0 0 2.678-5.491c0-2.09-.916-3.963-2.364-5.226zM10.626 15.313V6.455h8.71l-8.71 8.858zm1.96 10.232 7.936-8.075c1.945.264 3.465 1.95 3.465 4.008 0 2.249-1.8 4.067-3.988 4.067h-7.413z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBand);
export default __webpack_public_path__ + "static/media/BAND.efb20dfb9e174cc43cc19b874ec6450e.svg";
export { ForwardRef as ReactComponent };